<!-- <template>
  <div>
    <slot name="allowed"></slot>
    <slot name="not-allowed">
      <el-tooltip class="item" effect="dark" placement="left">
        <template slot="content">
          <span v-html="_markdown.renderInline(content)"></span>
        </template>
        <slot name="not-allowed-icon"><i class="far fa-lock-alt"></i></slot>
      </el-tooltip>
    </slot>
  </div>
</template> -->

<script>
/* eslint-disable object-shorthand */
import { get, each } from 'lodash';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt();

// import { capitalize } from 'utils';

export default {
  name: 'nuttrema-permissions-control-wrapper',
  props: {
    permissions: {
      required: true,
      default: null,
    },
    action: {
      required: false,
      default: null,
    },
    clarification: {
      type: Boolean,
      required: false,
      default: true,
    },
    requiredGeneral: {
      required: false,
      default: null,
    },
    requiredSubscribedPlan: {
      required: false,
      default: null,
    },
    controlType: {
      required: false,
      default: 'counter',
    },
    tooltipPlacement: {
      default: 'left',
    },
  },
  data() {
    return {
      forbiden: null,
    };
  },
  methods: {
    checkGeneralPermition() {
      const forbiden = [];
      if (!this.requiredGeneral) return forbiden;

      const permission = get(this.permissions, `general.${this.requiredGeneral}`, {});
      const allowed = get(permission, 'allowed', false) === true;

      if (!allowed) {
        const restrictedBy = get(permission, 'restricted_by') || false;

        const message = restrictedBy ? `permissions.restricted_by.${restrictedBy}` : 'permissions.action_is_not_allowed';

        forbiden.push({ message });
      }

      return forbiden;
    },
    checkSubscribedPlanPermition() {
      const forbiden = [];
      if (!this.requiredSubscribedPlan) return forbiden;

      const subscribed = get(this.permissions, `subscribed_plan.${this.requiredSubscribedPlan}`, false);

      if (!subscribed) {
        const message = 'permissions.subscribed_plan.missing_feature';
        const feature = `permissions.subscribed_plan.${this.requiredSubscribedPlan}`;
        forbiden.push({ message, feature });
      } else if (this.controlType === subscribed.control_type && subscribed.limit_reached) {
        const message = 'permissions.subscribed_plan.limit_reached';
        const feature = `permissions.subscribed_plan.${this.requiredSubscribedPlan}`;
        const upperLimit = subscribed.upper_limit;
        forbiden.push({ message, feature, upperLimit });
      }

      return forbiden;
    },
    checkIsForbiden() {
      const subscribedPlanPermition = this.checkSubscribedPlanPermition();
      if (subscribedPlanPermition.length > 0) return subscribedPlanPermition;

      const generalPermition = this.checkGeneralPermition();
      if (generalPermition.length > 0) return generalPermition;

      return [];
    },
    content(forbiden) {
      let content = '';

      each(forbiden, (item, index) => {
        if (index !== 0) content += '  \n';

        const message = get(item, 'message');

        const permition = get(item, 'permition');

        const feature = get(item, 'feature');
        const featureTrans = feature ? this.$t(item.feature) : false;
        const upperLimit = get(item, 'upperLimit');

        const permitionTrans = permition ? this.$t(item.permition) : false;
        const reasonTrans = this.$t(item.reason);

        const messageTrans = message ? this.$t(item.message, {
          permition: permitionTrans,
          feature: featureTrans,
          reason: reasonTrans,
          upper_limit: upperLimit,
        }) : '';

        content += messageTrans;
      });

      return md.render(content);
    },
  },
  render: function (createElement) {
    let element = {};
    const notAllowedContent = this.$slots['not-allowed'] || createElement('i', { class: 'far fa-lock-alt' });

    const forbiden = this.checkIsForbiden();

    if (forbiden.length === 0) {
      element = createElement('div', this.$slots.allowed);
    } else if (this.clarification) {
      const content = this.content(forbiden);

      element = createElement(
        'div',
        [
          createElement('el-tooltip', {
            props: {
              class: 'item',
              effect: 'dark',
              placement: this.tooltipPlacement,
            },
          }, [
            createElement('span', {
              slot: 'content',
              domProps: { innerHTML: content },
            }),
            notAllowedContent,
          ]),
        ],
      );
    } else {
      element = createElement('div', {
        style: 'display: none',
      });
    }

    return element && element.children ? element.children[0] : element;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/permissions/nuttrema-permissions-control-wrapper.vue